import React, { Component } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import PeopleSchedule from './PeopleSchedulle'
import ProjectSchedulle from './ProjectSchedulle'
import PeopleStatisticSchedulle from './PeopleStatisticSchedulle'
import './scheduller.css'

export default class MainScheduleBoard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            viewType: 0
        };
        
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange = name => evt => {
        this.setState({[name]: evt.target.value });
    }

    render() {
        return (
            <div>
                <Select
                    value={this.state.viewType}
                    onChange={this.handleChange('viewType')}
                >
                    <MenuItem value={0}>Календарь</MenuItem>
                    <MenuItem value={1}>Статистика по проектам</MenuItem>
                    <MenuItem value={2}>Статистика по людям</MenuItem>
                </Select>
                {this.state.viewType === 0 && <PeopleSchedule/>}
                {this.state.viewType === 1 && <ProjectSchedulle/>}
                {this.state.viewType === 2 && <PeopleStatisticSchedulle/>}
            </div>);
    }
}